import { render, staticRenderFns } from "./EmployerBrowser.vue?vue&type=template&id=47a5ebcc&scoped=true"
import script from "./EmployerBrowser.vue?vue&type=script&lang=js"
export * from "./EmployerBrowser.vue?vue&type=script&lang=js"
import style0 from "./EmployerBrowser.vue?vue&type=style&index=0&id=47a5ebcc&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a5ebcc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47a5ebcc')) {
      api.createRecord('47a5ebcc', component.options)
    } else {
      api.reload('47a5ebcc', component.options)
    }
    module.hot.accept("./EmployerBrowser.vue?vue&type=template&id=47a5ebcc&scoped=true", function () {
      api.rerender('47a5ebcc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Guide/components/SetupWizard/EmployerBrowser.vue"
export default component.exports